import ContractBasisDetails from 'app/Apps/Pricing/ContractBasis/ContractBasisDetails/ContractBasisDetails'
import {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import {
    ContractBasisTable,
} from 'app/Apps/Pricing/Pricing.types'
import {
    CommonRoutes,
    FilterType,
} from 'app/enums/common.enums'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    RequestConfig,
} from 'app/types/request.types'
import ContractBasisRequests from 'app/requests/ContractBasis/ContractBasis.requests'
import {
    ContractBasisTabs,
    PricingDomains,
} from 'app/enums/domain.enums'
import {
    SkyNetDataGridFilterType,
    SkyDataGridColumnDefinition,
} from 'app/shared-components/SkyBaseDataGrid'

import {
    SkyNetObjectConfigParams,
} from 'app/shared-components/SkyNetObjectProfile'
import ContractBasisDemoAdditionalFees from './ContractBasisDemoAdditionalFees'
import ContractBasisDemoCreateQuote from './ContractBasisDemoCreateQuote'
import ContractBasisDemoLaneGroups from './ContractBasisDemoLaneGroups'

const NDA_LABEL = 'NDA'

type ContractBasisTableFields = ContractBasisTable & {
    additionalFeesValidTo?: string
}

const columns: SkyDataGridColumnDefinition<ContractBasisTableFields>[] = [
    {
        name: 'contractBasisNumber',
        reduced: true,
        labelKey: 'CONTRACT_BASIS_ID',
    },
    {
        name: 'customerQuotationLocationName',
        filterField: 'customerQuotationLocationName',
        filterType: FilterType.Array,
        reduced: true,
        labelKey: 'CUSTOMER_QUOTATION',
    },
    {
        name: 'accountCompanyCompanyName',
        filterField: 'accountCompanyCompanyName',
        filterType: FilterType.Array,
        mapCellProps: ({
            hasNDA,
            accountCompanyCompanyName,
        }) => {
            return {
                children: `${hasNDA ? NDA_LABEL : accountCompanyCompanyName}`,
            }
        },
        reduced: true,
        customFilterItemLabelConverter: (value) => {
            return value || NDA_LABEL
        },
        labelKey: 'PRICING_ACCOUNT',
    },
    {
        name: 'accountIsStrategicAccount',
        componentName: 'ChipCheckMark',
        labelKey: 'IS_STRATEGIC_ACCOUNT',
    },
    {
        name: 'currency',
        filterField: 'currency',
        filterType: FilterType.Array,
        labelKey: 'CURRENCY',
    },
    {
        name: 'keyAccountManager',
        filterField: 'keyAccountManager',
        filterType: FilterType.Array,
        labelKey: 'KEY_ACCOUNT_MANAGER',
    },
    {
        name: 'businessDevelopers',
        filterField: 'businessDevelopers',
        filterType: FilterType.Array,
        componentName: 'List',
        labelKey: 'BUSINESS_DEVELOPERS',
    },
    {
        name: 'additionalFeesValidTo',
        filterField: 'additionalFeesValidTo',
        filterType: SkyNetDataGridFilterType.TimeLessDateRange,
        componentName: 'LaneDateEnriched',
        labelKey: 'ADDITIONAL_FEES_VALID_TO',
    },
]

const request: RequestConfig = {
    url: 'contractbasis/filter-request/all',
    method: 'POST',
} // TODO-DK: for test purposes only, remove it afterwards, take from requests.ts

export const formViews: SidebarTab[] = [
    {
        label: 'Contract Basis',
        url: PricingDomains.ContractBasis,
        Component: ContractBasisDetails,
        skyNetQueryLoaderConfig: {
            requestConfigFunction: ContractBasisRequests.get,
            requestKey: RequestKeys.getContractBasis,
        },
    },
    {
        label: 'Additional Fees',
        url: ContractBasisTabs.AdditionalFees,
        Component: ContractBasisDemoAdditionalFees,
        skyNetQueryLoaderConfig: {
            requestConfigFunction: ContractBasisRequests.get,
            requestKey: RequestKeys.getContractBasis,
        },
    },
    {
        label: 'Lane Groups',
        url: ContractBasisTabs.LaneGroups,
        Component: ContractBasisDemoLaneGroups,
        skyNetQueryLoaderConfig: {
            requestConfigFunction: ContractBasisRequests.get,
            requestKey: RequestKeys.getContractBasis,
        },
    },
    {
        label: 'Create Quote',
        url: ContractBasisTabs.CreateQuote,
        Component: ContractBasisDemoCreateQuote,
        skyNetQueryLoaderConfig: {
            requestConfigFunction: ContractBasisRequests.get,
            requestKey: RequestKeys.getContractBasis,
        },
        accessOnly: ['contract_basis_create'],
    },
]

const ContractBasisDemoConfig: SkyNetObjectConfigParams<ContractBasisTableFields> = {
    persistentKey: 'demo-contractBasis-table',
    formViews,
    columns,
    uniqField: 'id',
    config: [{
        url: CommonRoutes.All,
        name: 'All',
        requestKey: RequestKeys.getContractBasisList,
        request,
    }],
    actionComponents: {
        Create: {
            component: ContractBasisDetails,
            accessOnly: ['contract_basis_create'],
        },
    },
}

export default ContractBasisDemoConfig
